<template>
<!--  -->
<section class="hero is-primary has-background-white">
  <div class="hero-head">
    <!-- <div class="box needs-padding is-border-green stblue-background"> -->
        <div class="field" >
          <br>
          <img src="./../assets/myfitlogo.png" width="10%" alt="myfit app logo"/>
          <!-- <label class="label has-text-black calibri font-size-150 m-t-12">Smart Tile</label> -->
        </div>
    <!-- </div> -->
  </div>
  <div class="hero-body has-background-white left">
    <div class="container ">
      <video ref="videoRef" v-bind:src="source" id="video-container" width="70%" muted poster="https://test.smarttile.co.uk/stdemovideo.png"></video>
    </div>
  </div>
  <div class="modal is-active" v-if="showModal">
      <div class="modal-background"></div>
      <div class="modal-card">
            <header class="modal-card-head">
            <p class="modal-card-title"></p>
            <button class="delete" aria-label="close" @click="closeModal"></button>
          </header>
          <section class="modal-card-body has-text-dark">
            <div class="content">
              <h1>Access granted for {{member}}</h1>
              <h1>to {{gate}}</h1>
              <h1>Thank you for using My Fit App</h1>
            </div>
            
          </section>
      </div>
    </div>
    <div class="container">
      <img src="./../assets/smarttile.svg" width="100%" alt="Smart Tile logo"/>
      <div class="field" >
        <label class="black-foreground calibri"> © Copyright 2020 CCTech Ltd | All Rights Reserved </label>
      </div>
    </div>
</section>
</template>

<script>
export default {
  data(){
    return{
      member: 'Member1',
      location: 'Location1',
      gate: 'Gate1',
      source: "https://test.smarttile.co.uk/stdemovideo.webm",
      showModal: false,
    };
  },
  props: {
    msg: String
  },
  mounted: function(){

  },
  created(){
    this.$demoHub.$on('demo-changed', this.onDemoChanged)
  },
  methods:{
    onDemoChanged({member, location, gate}){
      setTimeout(() => {
          // this.$refs.videoRef.pause();
          this.showModal = true;
          this.member = member;
          this.location = location;
          this.gate = gate;
          setTimeout(() => {
            if(this.showModal){
              this.closeModal();
            }
          }, 7000);
          
        }, 3900);
        this.$refs.videoRef.play();
    },
    closeModal(){
      this.$refs.videoRef.load();
      this.showModal = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.left{
  margin-left: 100px;
}
.black-foreground{
  color: #000;
}
.black-background {
  background-color: #000;
}
</style>
